import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const ActionModalBody = styled.div`
  padding: 32px 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ActionModalTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 1.4;
  color: ${theme.blackText};
  margin-bottom: 8px;
`;

export const ActionModalMessage = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${theme.greyText6};
  margin-bottom: 24px;
`;
